import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SectionTitle } from "../site/Reveal";

const cats = [
  { name: "Fashion", to: "/shop?category=Fashion", img: "/images/cat-fashion.jpg", band: "bg-magenta", span: "col-span-2 lg:row-span-2 h-[420px] lg:h-auto" },
  { name: "Accessories", to: "/shop?category=Accessories", img: "/images/cat-accessories.jpg", band: "bg-tangerine-deep", span: "col-span-2 h-[300px] lg:h-auto" },
  { name: "Home & Living", to: "/shop?category=Home%20%26%20Living", img: "/images/rose-candles.jpg", band: "bg-teal", span: "col-span-1 h-[300px] lg:h-auto" },
  { name: "Gifts & More", to: "/shop?category=Gifts", img: "/images/gift-pink.jpg", band: "bg-orchid", span: "col-span-1 h-[300px] lg:h-auto" },
];

const CatCard = ({ c, i }) => (
  <motion.div
    className={`${c.span}`}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
  >
    <Link to={c.to} data-testid={`category-${c.name.toLowerCase().replace(/[^a-z]+/g, "-")}-card`} className="group relative block h-full overflow-hidden rounded-[2rem]">
      <img src={c.img} alt={c.name} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.4s] ease-[cubic-bezier(.22,1,.36,1)] group-hover:scale-110" />
      <div className="absolute inset-0 bg-gradient-to-t from-plum/30 to-transparent" />
      <div className={`absolute inset-x-0 bottom-0 flex items-center justify-between gap-3 ${c.band} px-5 py-4 sm:px-7 sm:py-5 text-white transition-[padding] duration-500 group-hover:pb-7`}>
        <div>
          <p className="font-display text-xl sm:text-3xl italic leading-none">{c.name}</p>
          <p className="mt-2 text-[10px] font-bold uppercase tracking-[0.25em] text-white/90">Shop {c.name.split(" ")[0]}</p>
        </div>
        <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-white text-plum transition-transform duration-500 group-hover:rotate-45">
          <ArrowUpRight className="h-4 w-4" />
        </span>
      </div>
    </Link>
  </motion.div>
);

export const Categories = () => (
  <section data-testid="categories-section" className="mx-auto max-w-7xl px-4 sm:px-8 py-20 sm:py-28">
    <SectionTitle script="Shop By Category" eyebrow="Curated for you" testId="categories-heading" />
    <div className="mt-14 grid grid-cols-2 gap-4 sm:gap-6 lg:grid-cols-4 lg:grid-rows-2 lg:h-[680px]">
      {cats.map((c, i) => <CatCard key={c.name} c={c} i={i} />)}
    </div>
  </section>
);
